import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/vuetify'
import store from './store'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'animate.css'
import 'fullpage-vue/src/fullpage.css'
import VueFullpage from 'fullpage-vue'
import Introduction from '@/components/Introduction'
import AppSelector from '@/views/AppSelector'

import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
pdfMake.vfs = pdfFonts.pdfMake.vfs;

Vue.config.productionTip = false

store.dispatch('init')

Vue.use(VueFullpage)

Vue.component('introduction', Introduction)
Vue.component('app-selector', AppSelector)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDBpLABv5oXzJuDlrHBT5UYmjRbm_uo1Fw',
    libraries: 'places,geometry', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  }
})

router.beforeEach(Vue.prototype.$auth.authRedirectGuard())

// bind the vue instance to the app div
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')